"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var task_status_1 = __importDefault(require("./constants/task-status"));
var storage_keys_1 = __importDefault(require("./constants/storage-keys"));
var ff_api_names_1 = __importDefault(require("./constants/ff-api-names"));
var kafka_rest_proxy_request_1 = require("./requests/kafka-rest-proxy-request");
var storage_1 = require("./helpers/storage");
var EventManager = /** @class */ (function () {
    function EventManager(eventConfiguration, dataLayerInterceptor, eventInterceptor) {
        this.apiKey = eventConfiguration.apiKey;
        this.persistMethod = eventConfiguration.persistMethod;
        this.eventManagerKey = eventConfiguration.eventManagerKey;
        this.retries = eventConfiguration.retries;
        this.schemaId = eventConfiguration.schemaId;
        this.url = eventConfiguration.url;
        this.dataLayerInterceptor = dataLayerInterceptor;
        this.eventInterceptor = eventInterceptor;
    }
    EventManager.prototype.addEvent = function (json) {
        var isInternalApp = !!((0, firefly_utilities_helper_ts_1.isString)(this.url) && this.url.includes(ff_api_names_1.default.internalApps));
        var result = appendToDataLayer(this.eventManagerKey, json, this.dataLayerInterceptor, this.persistMethod);
        var decoratedJson = this.eventInterceptor.apply(result, this.persistMethod, isInternalApp);
        return (0, kafka_rest_proxy_request_1.sendEvent)(decoratedJson, this.apiKey, this.schemaId, this.url, this.retries);
    };
    EventManager.prototype.addTaskCancelEvent = function (json) {
        var taskInit = { task: { status: task_status_1.default.CANCELLED } };
        var modifiedJSON = firefly_utilities_ts_1.Utilities.extend(json, taskInit);
        this.addEvent(modifiedJSON);
    };
    EventManager.prototype.addTaskFailEvent = function (json) {
        var taskInit = { task: { status: task_status_1.default.FAIL } };
        var modifiedJSON = firefly_utilities_ts_1.Utilities.extend(json, taskInit);
        this.addEvent(modifiedJSON);
    };
    EventManager.prototype.addTaskInitEvent = function (json) {
        var taskInit = { task: { status: task_status_1.default.INIT } };
        var modifiedJSON = firefly_utilities_ts_1.Utilities.extend(json, taskInit);
        this.addEvent(modifiedJSON);
    };
    EventManager.prototype.addTaskSuccessEvent = function (json) {
        var taskInit = { task: { status: task_status_1.default.SUCCESS } };
        var modifiedJSON = firefly_utilities_ts_1.Utilities.extend(json, taskInit);
        this.addEvent(modifiedJSON);
    };
    EventManager.prototype.appendToDataLayer = function (json) {
        return appendToDataLayer(this.eventManagerKey, json, this.dataLayerInterceptor, this.persistMethod);
    };
    EventManager.prototype.clearDataLayer = function () {
        firefly_utilities_ts_1.PersistenceManager.remove(this.eventManagerKey + storage_keys_1.default.DATA_LAYER, this.persistMethod);
    };
    EventManager.prototype.setDataLayer = function (json) {
        var decoratedJson = this.dataLayerInterceptor.apply(json);
        persistDataLayer(decoratedJson, this.eventManagerKey, this.persistMethod);
    };
    return EventManager;
}());
exports.default = EventManager;
function appendToDataLayer(eventManagerKey, json, interceptor, persistMethod) {
    var dataLayer;
    var persistedDataLayer = (0, storage_1.getDataFromStorage)(eventManagerKey, persistMethod, storage_keys_1.default.DATA_LAYER);
    if ((0, firefly_utilities_helper_ts_1.isObject)(persistedDataLayer)) {
        dataLayer = firefly_utilities_ts_1.Utilities.extend(persistedDataLayer, json);
    }
    else {
        dataLayer = interceptor.apply(json);
    }
    persistDataLayer(dataLayer, eventManagerKey, persistMethod);
    return dataLayer;
}
function persistDataLayer(json, eventManagerKey, persistMethod) {
    (0, storage_1.setDataToStorage)(json, eventManagerKey, persistMethod, storage_keys_1.default.DATA_LAYER);
}
